import { Buffer } from "buffer";

/**
 * [parseJwt Parses a jwt token]
 * @param  {String} token
 * @return {Object} Returns parsed object
 */
export default function parseJwt(token) {
  return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
}
